import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type Operator = {
  operatorId: string
  name: string | null
  email: string
  avatarUrl: string | null
}
type GetOperatorsResponse = Operator[]

export function useGetAll() {
  return useQuery({
    queryKey: ['mission-specialist-all'],
    queryFn: async () => {
      const { data } = await apiClient.get<GetOperatorsResponse>('/int/v3/operators', {
        params: { roles: ['operator', 'admin'] },
      })

      return data.map((operator) => ({
        name: operator.name,
        email: operator.email,
        appUserId: operator.operatorId,
        avatarUrl: operator.avatarUrl,
      }))
    },
    refetchOnWindowFocus: false,
  })
}
